// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__W1TTO","fill":"Button_fill__9OZyR"};